import React from "react";

const AuthErrorBox = ({ errors }) => (
  errors && errors.length > 0 ? (
    <div className="error">
      {errors.map((msg, i) => <p key={i}>{String(msg)}</p>)}
    </div>
  ) : null
);

export default AuthErrorBox;
